import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as XCircle } from 'assets/images/x-circle-fine.svg';

export const XCircleIcon = styled(XCircle)`
  width: 24px;
  height: 24px;
  color: ${ColorPalette.HEX.Manatee};
  margin: 32px 24px 0;
`;
